/** 票券使用效期 (天) */
export enum TicketValidityPeriod {
  ONE_MONTH = '30',
  THREE_MONTH = '90',
  FOUR_MONTH = '120',
  ONE_YEAR = '365'
}
